import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocaleId } from '../models/locale.model';
import { ReportRecord } from '../models/report.model';
import { CustomDataRetriever } from './custom-data-retriever.abstract';

export interface CustomDataTable {
  [recordId: number]: {
    header: string[];
    data: string[][];
  };
}

interface StaticOfferedSpaceRecord {
  floor: string;
  usage: string;
  sqm: string;
  available: string;
}

@Injectable()
export class OfferedSpaceService extends CustomDataRetriever {
  constructor(private http: HttpClient) {
    super();
  }

  getCustomData(
    reportId: number,
    templateId: number,
    locale: LocaleId,
    payload: any,
    record: ReportRecord
  ): Observable<StaticOfferedSpaceRecord[]> {
    const offeredSpace$ = this.getOfferedSpace(reportId, templateId, locale, payload);
    return offeredSpace$.pipe(map(offeredSpace => this.mapIntoStaticOfferedSpace(offeredSpace, record)));
  }

  private getOfferedSpace(
    reportId: number,
    templateId: number,
    locale: LocaleId,
    payload: any
  ): Observable<CustomDataTable> {
    const uri = `/api/reports/${reportId}/customdata?type=offeredSpace`;
    const templateIdParam = `templateID=${templateId}`;
    const viewParam = `view=table`;
    const localeParam = `locale=${locale}`;

    const finalUri = `${uri}&${templateIdParam}&${viewParam}&${localeParam}`;
    return this.cachedCustomData(finalUri, this.http.post.bind(this.http, finalUri, payload));
  }

  private mapIntoStaticOfferedSpace(offeredSpace: CustomDataTable, record: ReportRecord): StaticOfferedSpaceRecord[] {
    if (offeredSpace == null) {
      return [];
    }
    const { edpRecordId } = record;
    const recordOfferedSpace = offeredSpace[edpRecordId];

    if (recordOfferedSpace == null) {
      return [];
    }

    const { data } = recordOfferedSpace;

    return data.map(row => {
      /*
       * NOTE 1: this mapping should not be happening, but we are using objects
       *         due to windward not supporting the original interface
       * NOTE 2: we have two scenarios: longlist & shortlist. The longlist
       *         only needs the **four** attributes we are sending in the "if"
       *         block. However, the shortlist needs the **eight** attributes we
       *         are sending in the "else" block.
       */
      if (row != null && row.length === 4) {
        const [floor, usage, sqm, available] = row;
        return { floor, usage, sqm, available };
      } else {
        const [floor, qualitySpace, noOfWorkspaces, sqm, available, leaseType, usage, askingRent] = row;
        return { floor, qualitySpace, noOfWorkspaces, sqm, available, leaseType, usage, askingRent };
      }
    });
  }
}
